import Vue from "vue";
import Analytics from "analytics";
import fullStoryPlugin from "@analytics/fullstory";

export const initializeFullStory = function () {
  var loginData = JSON.parse(Vue.ls.get("login_data"));
  if (process.env.VUE_APP_FULLSTORY_CODE && loginData && loginData.token) {
    initiateFullStory(loginData);
  } else {
    destroyFullStory();
  }
};

const initiateFullStory = function (loginData) {
  if (!window.FS) {
    const analytics = Analytics({
      app: "mailercloud-app",
      plugins: [
        fullStoryPlugin({
          org: process.env.VUE_APP_FULLSTORY_CODE,
        }),
      ],
    });

    /* Identify a visitor */
    analytics.identify("Client-" + loginData.cid + "", {
      displayName: Vue.ls.get("clientName"),
      email: loginData.user,
      reviewsWritten_int: 14,
    });
    // window.FS.shutdown() will terminate full story temperorily
  } else {
    window.FS.clearUserCookie();
    window.FS.identify("Client-" + loginData.cid + "", {
      displayName: Vue.ls.get("clientName"),
      email: loginData.user,
      reviewsWritten_int: 14,
    });
    window.FS.restart();
  }
};

export const destroyFullStory = function () {
  if (window.FS) {
    window.FS.shutdown();
    // delete window.FS
  }
};
